/**
 * Formatting helpers for reading passages (case studies).
 *
 * Generated passages lead with their title on the first line, then a blank line,
 * then the body — see the `passage.generate` prompt. Keeping the split in one place
 * means every screen renders a passage the same way (title bold, spaced from the
 * body), and the automatic flow can feed that exact title back into the question
 * prompt so every question names the passage identically.
 */

/** Splits a passage into `{ title, body }`. Falls back to all-body when untitled. */
export const splitPassage = (raw) => {
  const text = String(raw || '').replace(/\r\n/g, '\n').trim();
  if (!text) return { title: '', body: '' };

  const [firstLine, ...rest] = text.split('\n');
  const title = firstLine
    .trim()
    .replace(/^#+\s*/, '')
    .replace(/^title:\s*/i, '')
    .replace(/^["']|["']$/g, '');
  const body = rest.join('\n').trim();

  // A one-line passage, or a "title" long enough to be prose, means the text does not
  // follow the format (e.g. an older or hand-edited passage) — treat the whole thing
  // as the body so nothing is hidden.
  if (!body || title.length > 120) {
    return { title: '', body: text };
  }
  return { title, body };
};

export default splitPassage;
